import { Select } from "antd";
import React from "react";
import close from "../assets/cancel.svg";
const { Option } = Select;
const SelectComponent = (props) => {
  return (
    <div className="select-wrap">
      <label>{props.label}</label>
      <Select
        mode={props?.mode}
        placeholder={props.placeholder ? props.placeholder : "Select Option"}
        onChange={props.onChange}
        value={props.value}
        // Case-insensitive filtering + special handling for Size
        filterOption={(input, option) => {
          const inputLc = (input || "").toLowerCase();
          if (props.label === "Size") {
            // Case-insensitive match on the displayed text
            const text = (option?.children ?? "").toString();
            const fullMatch = text.toLowerCase().includes(inputLc);
            const normalizedOption = text.replace(/\D/g, ""); // Numeric-only match: "22560R17" matches "225/60R17" etc.
            const normalizedInput = (input || "").replace(/\D/g, "");
            const numericMatch = normalizedInput !== "" && normalizedOption.includes(normalizedInput);

            return fullMatch || numericMatch;
          }
          // Default: case-insensitive text or key match
          const textLc = ((option?.children ?? "").toString()).toLowerCase();
          const keyLc = ((option?.key ?? "").toString()).toLowerCase();
          return textLc.includes(inputLc) || keyLc.includes(inputLc);
        }}
      >
        {props.options?.length > 0 &&
          props.options?.map((ele) => (
            <Option key={ele.value} value={ele.value}>
              {ele.label}
            </Option>
          ))}
      </Select>
      {props.value && (
        <img
          className="cancel mlHalf"
          src={close}
          alt={"close"}
          width={14}
          onClick={props.onClear}
        />
      )}
    </div>
  );
};

export default SelectComponent;
